import { api } from 'common';

import { GenerateFileBlockFormFields } from './FormFields.tsx';
import { GenerateFileBlockDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

import Mode = api.FlowDefinition.GenerateFile.Mode;

type GenerateFileBlockConfig = api.FlowDefinition.GenerateFile.GenerateFileBlockConfig;

export const GenerateFileConfig: BlockConfigProps<GenerateFileBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'generateFile',
  defaultConfig: {
    mode: Mode.Markdown,
    markdown: '',
  },
  configFields: {
    schema: api.FlowDefinition.GenerateFile.GenerateFileBlockConfigSchema,
    FormFields: GenerateFileBlockFormFields,
  },
  documentationMarkdown: GenerateFileBlockDocumentation,
};
